import axios from "axios";
import { EventEmitter } from "eventemitter3";

export default class UploadBlockService extends EventEmitter {
  constructor(url, headers) {
    super();
    this.url = url;
    this.headers = headers || {};
  }

  execute(fileId, uploadId, stream, block, cancelToken) {
    const { url } = this;
    const { seq, size } = block;
    const formData = new FormData();
    formData.append("seq", seq);
    formData.append("size", size);
    formData.append("file", stream);
    formData.append("fileId", fileId);
    formData.append("uploadId", uploadId);
    const headers = {
      ...this.headers,
      "Content-Type": "multipart/form-data",
    };
    axios
      .post(url, formData, {
        headers,
        cancelToken,
        onUploadProgress: (event) => {
          this.emit("uploadBytes", event.bytes);
        },
      })
      .then((e) => {
        if (e.data.code !== 200) {
          return this.emit("error", e.data.message);
        }
        this.emit("complete", e.data);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          return this.emit("abort");
        }
        this.emit("error", err);
      });
  }
}
